module.exports = __webpack_public_path__ + "static/sandra-10e17ed8cf581f4c3ab345a0cc4fd8a2.png";